import React from "react";
import { Col, Image, Row, Typography } from "antd";
import ConvocatoriaImage from "../../../../../assets/landing/LogoConvocatoriaGeneric.PNG";
import "./hero-beps.style.scss";

export const HeroBeps = () => {
  return (
  
    <div className="container-background-participantes">
      <div className="subcontainer-background-participantes">
	<div className="container-fluid2">
         <div className="row ">
            <div className="col-4 col-md-2 me-md-4 mt-5 mb-md-5">
               <Image src={ConvocatoriaImage} className="img__hero" preview={false} />
            </div>
            <div className="col-12 col-md-9 mt-5 mb-5 d-flex align-items-center">
               <div className="col-12">
                  <div
                  style={{ lineHeight: "normal" }}
                  className="d-flex font-family-Montserrat-Bold font-size-22px font-color-FFFFFF texto-sombras-general"
                  >
                  Formulario de inscripción BEPS
               </div>
               <div
               style={{ lineHeight: "normal" }}
               className="d-flex mt-3 font-family-Montserrat-Regular font-size-16px font-color-FFFFFF subtexto-sombras-general"
               >
               Bienvenido, desde aquí puedes hacer seguimiento de tus postulaciones a las convocatorias de fomento y
              estímulos para el arte y cultura. Buscar nuevas convocatorias y/o participar como jurado.
            </div>
         </div>
      </div>
   </div>
</div>


      </div>
    </div>
  );
};
